import React, { useState, useEffect } from "react";
import { FaSearch, FaHistory, FaVideo, FaWallet } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function AdminVideoManager() {
  const [branches, setBranches] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const BRANCH_LIST_URL = `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`;
  // Fetch branches to manage access
  useEffect(() => {
    // Reuse your existing branch fetch logic here
    fetch(
      `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`,
    )
      .then((res) => res.json())
      .then((data) => setBranches(data.branches || []));
  }, []);

  // const handleGlobalUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setUploading(true);
  //   const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB per chunk
  //   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

  //   try {
  //     // 1. Initialize Multipart Upload
  //     const initRes = await fetch(API_ENDPOINT, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         action: "START_MULTIPART",
  //         fileName: file.name,
  //         fileType: file.type,
  //       }),
  //     });
  //     const { uploadId, key } = await initRes.json();

  //     const parts = [];

  //     // 2. Upload Chunks
  //     for (let i = 0; i < totalChunks; i++) {
  //       const start = i * CHUNK_SIZE;
  //       const end = Math.min(start + CHUNK_SIZE, file.size);
  //       const chunk = file.slice(start, end);

  //       // Get Presigned URL for this specific part
  //       // Inside your upload loop
  //       const partRes = await fetch(API_ENDPOINT, {
  //         method: "POST",
  //         body: JSON.stringify({
  //           action: "GET_PART_URL",
  //           uploadId,
  //           key,
  //           partNumber: i + 1,
  //         }),
  //       });

  //       const data = await partRes.json();

  //       if (!data.partUrl) {
  //         throw new Error(
  //           `Failed to get Part URL for chunk ${i + 1}. Check Lambda logs.`,
  //         );
  //       }

  //       // Only now do the PUT
  //       const uploadPartRes = await fetch(data.partUrl, {
  //         method: "PUT",
  //         body: chunk,
  //       });
  //       const eTag = uploadPartRes.headers.get("ETag");

  //       parts.push({ ETag: eTag, PartNumber: i + 1 });
  //       console.log(`Uploaded part ${i + 1} of ${totalChunks}`);
  //     }

  //     // 3. Complete Multipart Upload
  //     await fetch(API_ENDPOINT, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         action: "COMPLETE_MULTIPART",
  //         uploadId,
  //         key,
  //         parts,
  //       }),
  //     });

  //     alert("Video Uploaded Successfully!");
  //   } catch (err) {
  //     console.error("Multipart Upload Error:", err);
  //     alert("Upload failed. Ensure you have a stable high-speed connection.");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const updateBranchAccess = async (id, status) => {
    setLoading(true);
    try {
      await fetch(BRANCH_LIST_URL, {
        method: "PATCH",
        body: JSON.stringify({ id, hasViewedDemo: status }),
      });
      setLoading(false);
      alert("Access Updated");
    } catch (err) {
      console.error(err);
    }
  };
  if (loading) {
    return (
      <div className="modern-loading-overlay">
        <div className="loader-content">
          <div className="shimmer-card">
            <div className="icon-pulse">
              <FaWallet className="floating-wallet" />
            </div>
            <div className="loading-bar-container">
              <div className="loading-bar-progress"></div>
            </div>
            <p className="loading-text">Loading Data Please Wait...</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="admin-video-page">
      <header className="page-header">
        <h1>
          <FaVideo /> Video Control Center
        </h1>
        <Link to="/" className="Branch-nav">
          Back To Admin
        </Link>
        <p>Manage global demo videos and branch-wise access permissions.</p>
      </header>

      <div className="admin-grid">
        {/* GLOBAL UPLOAD BOX */}
        {/* <section className="control-card">
          <h2>Global Settings</h2>
          
          <div className="upload-zone">
            <input
              type="file"
              accept="video/mp4"
              onChange={handleGlobalUpload}
              id="video-up"
              hidden
            />
            <label htmlFor="video-up" className="upload-label">
              {uploading ? "Processing..." : "Click to Upload New Master Video"}
            </label>
            <button className="btn-danger">
              <FaTrash /> Disable Video for All
            </button>
          </div>
        </section> */}

        {/* BRANCH ACCESS SEARCH */}
        <section className="control-card">
          <h2>Branch Permissions</h2>
          <div className="search-box">
            <FaSearch />
            <input
              type="text"
              placeholder="Search branch name..."
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="branch-list-mini">
            {branches
              .filter((b) =>
                b.branchName.toLowerCase().includes(search.toLowerCase()),
              )
              .map((b) => (
                <div key={b.id} className="branch-access-row">
                  <span>{b.branchName}</span>
                  <div className="row-actions">
                    <button
                      onClick={() => updateBranchAccess(b.id, false)}
                      title="Re-watch Video"
                    >
                      <FaHistory /> Enable Video
                    </button>
                    <button
                      onClick={() => updateBranchAccess(b.id, true)}
                      title="Block Video"
                    >
                      Block Video
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </section>
      </div>
    </div>
  );
}
